import { dataset_dev } from "svelte/internal";
import { writable, get } from "svelte/store";
import * as util from "../js/util.js";
import { calculatorStore } from "./calculators.js";
import { countryStore } from "./countries.js";
import { db } from "./db.js";
import { loggedInUserStore } from "./loggedInUser.js";

if (1 == 0) {
  // save this for multi tab syncing of the data... but not really needed
  db.on("changes", function (changes) {
    changes.forEach(function (change) {
      if (
        change.table == "factories" &&
        change.obj.userId == get(loggedInUserStore).uuid
      ) {
        factoryStore.getFactories();
      }
    });
  });
}
let isBusySync = false;
function sortByChangeDate(a, b) {
  return a.changeDate < b.changeDate ? 1 : -1;
  return 0;
}
let syncTimeout;

function createMyStore() {
  var onlinemode = localStorage.getItem("onlinemode") + "";
  if (onlinemode != "offline") {
    onlinemode = "online";
  }
  const { subscribe, set, update } = writable({
    isBusySync,
    currencies: [],
    factories: new Array(),
    products: new Array(),
    currentCalculator: {},
    currentFactory: {},
    showSuperHelp: false,
    lastSyncDate: 0,
    onlinemode: onlinemode,
  });

  return {
    subscribe,
    update,
    set,
    update,
    getFactories: async () => {
      var userId = get(loggedInUserStore).uuid;
      if (userId == null || userId.length == 0) {
        update((n) => Object.assign(n, { factories: [] }));
      } else {
        const all = await db.factories.where("userId").equals(userId).toArray();
        update((n) => Object.assign(n, { factories: all }));
      }
    },

    getFactory: async (factoryId) => {
      var userId = get(loggedInUserStore).uuid;
      if (userId == null || userId.length == 0) {
        return [];
      } else {
        var ret = await db.factories.get(factoryId);
        if (ret.userId != userId) {
          alert("invalid user");
          return;
        }
        return ret;
      }
    },
    showSuperHelp: (isShow, title, longtext) => {
      update((n) =>
        Object.assign(n, {
          showSuperHelp: isShow,
          superHelpTitle: title,
          superHelpLongText: longtext,
        })
      );
    },
    setLocked: (isLocked) => {
      update((n) =>
        Object.assign(n, {
          currentCalculator: Object.assign(n.currentCalculator, { isLocked }),
        })
      );
    },
    downloadFactory: async (factorySettingId) => {
      var factorySetting = await factoryStore.getFactorySettings(
        factorySettingId
      );
      var json = JSON.stringify(factorySetting);
      util.saveAsFile(json, `factorysetting-${factorySetting.name}.json`);
      var factory = await factoryStore.getFactory(factorySetting.factoryId);
      var json2 = JSON.stringify(factory);
      util.saveAsFile(json2, `factory-${factory.name}.json`);
    },
    downloadProduct: async (productId) => {
      var product = await factoryStore.getProduct(productId);
      var json = JSON.stringify(product);
      util.saveAsFile(json, `product-${product.name}.json`);
    },
    generatePdf: async (product) => {
      product.productName = product.name;
      product.factorySettingName = await factoryStore.getFactorySettingName(
        product.factorySettingId
      );
      product.factoryName = await factoryStore.getFactoryName(
        product.factorySettingId
      );
      product.targetWage =
        product.scenarioConfiguration.scenarioVarValues["target-wage"]["Wage"];
      await util.fetchFileWithMethod(
        "POST",
        "api/Country/generatepdf",
        product,
        "ProductStyleCosting" +
          "_" +
          product.name.replace(" ", "") +
          "_" +
          product.brand.replace(" ", "") +
          "_" +
          product.style.replace(" ", "") +
          ".pdf"
      );
    },
    generateExcel: async (product) => {
      product.productName = product.name;
      product.factorySettingName = await factoryStore.getFactorySettingName(
        product.factorySettingId
      );
      product.factoryName =
        (await factoryStore.getFactoryName(product.factorySettingId)) + "";
      product.FactoryName = product.factoryName;
      product.targetWage =
        product.scenarioConfiguration.scenarioVarValues["target-wage"]["Wage"];
      await util.fetchFileWithMethod(
        "POST",
        "api/Country/generateexcel",
        product,
        "ProductStyleCosting" +
          "_" +
          product.name.replace(" ", "") +
          "_" +
          product.brand.replace(" ", "") +
          "_" +
          product.style.replace(" ", "") +
          ".xlsx"
      );
    },
    getCurrencies: async () => {
      const json = await util.fetchJson("api/Country/getallcurrencies");
      update((n) => Object.assign(n, { currencies: json }));
      return json;
    },
    getFactoryAndVersionName: async (factorySettingId) => {
      if (!factorySettingId) {
        //weird bug that the currentCalculator is not a calculator
        return;
      }
      var userId = get(loggedInUserStore).uuid;
      if (userId == null || userId.length == 0) {
        return [];
      } else {
        var factorySettings = await db.factorySettings.get(factorySettingId);
        if (!factorySettings) return ""; // factory might be deleted
        if (factorySettings.userId != userId) {
          alert("invalid user");
          return;
        }
        var factory = await db.factories.get(factorySettings.factoryId);
        if (!factory) return ""; //factory might be deleted
        return factory.name + " - " + factorySettings.name;
      }
    },
    getFactoryName: async (factorySettingId) => {
      var userId = get(loggedInUserStore).uuid;
      if (userId == null || userId.length == 0) {
        return [];
      } else {
        var factorySettings = await db.factorySettings.get(factorySettingId);
        if (!factorySettings) return ""; // factory might be deleted
        if (factorySettings.userId != userId) {
          alert("invalid user");
          return;
        }
        var factory = await db.factories.get(factorySettings.factoryId);
        if (!factory) return ""; //factory might be deleted
        return factory.name;
      }
    },
    getFactorySettingName: async (factorySettingId) => {
      var userId = get(loggedInUserStore).uuid;
      if (userId == null || userId.length == 0) {
        return [];
      } else {
        var factorySettings = await db.factorySettings.get(factorySettingId);
        if (!factorySettings) return ""; // factory might be deleted
        if (factorySettings.userId != userId) {
          alert("invalid user");
          return;
        }
        return factorySettings.name;
      }
    },
    getFactorySettingsForFactory: async (factoryId) => {
      var userId = get(loggedInUserStore).uuid;
      if (userId == null || userId.length == 0) {
        return [];
      } else {
        var ret = await db.factorySettings
          .where("factoryId")
          .equals(factoryId)
          .toArray();
        return ret.filter((i) => i.userId == userId);
      }
    },
    getFactorySettingsChangeDate: async (factorySettingsId) => {
      var userId = get(loggedInUserStore).uuid;
      if (userId == null || userId.length == 0) {
        return [];
      } else {
        var ret = await db.factorySettings.get(factorySettingsId);
        if (ret.userId != userId) {
          alert("invalid user");
          return;
        }
        return ret.changeDate;
      }
    },
    getFactorySettings: async (factorySettingsId) => {
      var userId = get(loggedInUserStore).uuid;
      if (userId == null || userId.length == 0) {
        return [];
      } else {
        var ret = await db.factorySettings.get(factorySettingsId);
        if (ret.userId != userId) {
          alert("invalid user");
          return;
        }

        update((n) => Object.assign(n, { currentCalculator: ret }));
        var factory = await db.factories.get(ret.factoryId);
        update((n) => Object.assign(n, { currentFactory: factory }));

        return ret;
      }
    },
    getProduct: async (productId) => {
      var userId = get(loggedInUserStore).uuid;
      if (userId == null || userId.length == 0) {
        return [];
      } else {
        var ret = await db.products.get(productId);
        if (ret.userId != userId) {
          alert("invalid user");
          return;
        }

        update((n) => Object.assign(n, { currentCalculator: ret }));
        var factory = await db.factories.get(ret.factoryId);
        update((n) => Object.assign(n, { currentFactory: factory }));

        return ret;
      }
    },
    copyFactorySettings: async (factorySettingsId, copyLabelText) => {
      var userId = get(loggedInUserStore).uuid;
      if (userId == null || userId.length == 0) {
        return [];
      } else {
        var ret = await db.factorySettings.get(factorySettingsId);
        if (ret.userId != userId) {
          alert("invalid user");
          return;
        }
        ret.uuid = null;
        ret.name = copyLabelText;
        await countryStore.getCountries();
        var countryStoreVal = get(countryStore);

        var factoryStoreVal = get(factoryStore);
        if (factoryStoreVal.onlinemode != "offline") {
          var oldCalculator = await calculatorStore.getCalculator(
            ret.countryVersionId
          );
          var country = countryStoreVal.find(
            (c) => c.id == oldCalculator.countryId
          );
          var calculator = await calculatorStore.getCalculator(
            country.version.id
          );
          var wageVarServer = calculator.variables.find((v) => {
            return v.varNameKey == "Wage";
          });
          var wageVarSetting = ret.variables.find((v) => {
            return v.varNameKey == "Wage";
          });
          if (wageVarServer != undefined && wageVarSetting != undefined) {
            wageVarSetting.value = wageVarServer.formula;
            wageVarSetting.formula = wageVarServer.formula;
            wageVarSetting.minValue = wageVarServer.minValue;
            wageVarSetting.maxValue = wageVarServer.maxValue;
          }
          wageVarServer = calculator.variables.find((v) => {
            return v.varNameKey == "TargetWage";
          });
          wageVarSetting = ret.variables.find((v) => {
            return v.varNameKey == "TargetWage";
          });
          if (wageVarServer != undefined && wageVarSetting != undefined) {
            wageVarSetting.value = wageVarServer.formula;
            wageVarSetting.formula = wageVarServer.formula;
            wageVarSetting.minValue = wageVarServer.minValue;
            wageVarSetting.maxValue = wageVarServer.maxValue;
          }
        }
        ret.changeDate = Date.now();
        return await factoryStore.saveFactoryOrProductSettings(ret);
      }
    },
    copyProduct: async (productId, copyLabelText) => {
      var userId = get(loggedInUserStore).uuid;
      if (userId == null || userId.length == 0) {
        return [];
      } else {
        var ret = await db.products.get(productId);
        if (ret.userId != userId) {
          alert("invalid user");
          return;
        }
        ret.uuid = null;
        ret.name = copyLabelText;
        return await factoryStore.saveFactoryOrProductSettings(ret, true);
      }
    },
    hasFactories: async () => {
      var userId = get(loggedInUserStore).uuid;
      if (!userId || userId.length == 0) return;
      return (await db.factories.where("userId").equals(userId).count()) > 0;
    },
    deleteFactorySetting: async (setting) => {
      var userId = get(loggedInUserStore).uuid;

      var ret = await util.fetchJsonWithMethod(
        "POST",
        "api/Sync/syncdatadelete",
        { userId: userId, tableName: "factorySettings", tableId: setting.uuid }
      );
      if (!ret.success) {
        alert("failed delete, please make sure you are online to delete");
        return;
      }
      var ret2 = await util.fetchJsonWithMethod(
        "POST",
        "api/Sync/syncdatadelete",
        { userId: userId, tableName: "factories", tableId: setting.factoryId }
      );
      if (!ret2.success) {
        alert("failed delete, please make sure you are online to delete");
        return;
      }

      db.factorySettings.delete(setting.uuid).then(async () => {
        var ret = await db.factorySettings
          .where("factoryId")
          .equals(setting.factoryId)
          .toArray();
        if (ret.length == 0) {
          db.factories.delete(setting.factoryId);
        }
      });
    },
    deleteProduct: async (product) => {
      var userId = get(loggedInUserStore).uuid;
      var ret = await util.fetchJsonWithMethod(
        "POST",
        "api/Sync/syncdatadelete",
        { userId: userId, tableName: "products", tableId: product.uuid }
      );
      if (!ret.success) {
        alert("failed delete, please make sure you are online to delete");
        return;
      }
      db.products.delete(product.uuid).then(async () => {});
    },
    saveFactory: async (factory) => {
      return await factoryStore.createOrUpdate(factory, db.factories);
    },
    setFactorySettingToCurrentProduct: async (factorySettingId) => {
      var userId = get(loggedInUserStore).uuid;
      var newFactorySetting = await db.factorySettings.get(factorySettingId);
      if (newFactorySetting.userId != userId) {
        alert("invalid user");
        return;
      }
      var currentProduct = get(factoryStore).currentCalculator;
      var inputSections = currentProduct.subSections.filter(
        (ss) => !ss.isSummarySection && !ss.isFactorySection
      );
      for (var subSection in inputSections) {
        for (var sectionVar in inputSections[subSection].variables) {
          var foundVar = currentProduct.variables.find(
            (v) =>
              v.varNameKey ==
              inputSections[subSection].variables[sectionVar].nameKey
          );
          if (!foundVar.readOnly && !foundVar.isFunction) {
            var overWriteVar = newFactorySetting.variables.find(
              (v) => v.varNameKey == foundVar.varNameKey
            );
            if (overWriteVar != undefined) {
              overWriteVar.value = foundVar.value;
            }
          }
        }
      }
      currentProduct.excelSheetNames = newFactorySetting.excelSheetNames;

      currentProduct.factorySettingChangeDate = newFactorySetting.changeDate;
      currentProduct.countryVersionId = newFactorySetting.countryVersionId;
      currentProduct.variables = newFactorySetting.variables;
      currentProduct.subSections = newFactorySetting.subSections;
      currentProduct.availableLangs = newFactorySetting.availableLangs;
      currentProduct.calculatorVersionNumber =
        newFactorySetting.calculatorVersionNumber;
      factoryStore.saveFactoryOrProductSettings(currentProduct, true);
    },
    saveFactoryOrProductSettings: async (factoryOrProductSettings) => {
      var isProductMode = factoryOrProductSettings.factorySettingId
        ? true
        : false;
      if (isProductMode) {
        var ret = await factoryStore.createOrUpdate(
          factoryOrProductSettings,
          db.products
        );
        //await factoryStore.getProduct(factoryOrProductSettings.uuid);
        return ret;
      }
      var ret = await factoryStore.createOrUpdate(
        factoryOrProductSettings,
        db.factorySettings
      );
      // await factoryStore.getFactorySettings(factoryOrProductSettings.uuid);
      return ret;
    },
    saveProduct: async (product) => {
      var factorySetting = await factoryStore.getFactorySettings(
        product.factorySettingId
      );
      product.factoryId = factorySetting.factoryId;
      product.factorySettingChangeDate = factorySetting.changeDate;
      product = { ...factorySetting, ...product };
      return await factoryStore.createOrUpdate(product, db.products);
    },
    findProducts: async (
      filter,
      numRecords,
      sortElement,
      sortDirection,
      factorySettingId
    ) => {
      var userId = get(loggedInUserStore).uuid;
      filter = filter.toLowerCase();
      var filterWords = filter.split(" ");
      var ret = await db.products.where("userId").equals(userId).toArray();
      ret = ret.filter(
        (p) =>
          filterWords.every(
            (fw) =>
              !p.style ||
              p.style.includes(fw) ||
              p.name.includes(fw) ||
              p.brand.includes(fw)
          ) &&
          (factorySettingId == null || factorySettingId == p.factorySettingId)
      );
      let totalFilteredProducts = ret.length;
      ret = ret.sort((f, g) =>
        f[sortElement] > g[sortElement] ? 1 * sortDirection : -1 * sortDirection
      );
      ret = ret.slice(0, numRecords);

      update((n) => Object.assign(n, { products: ret }));

      return { filteredProducts: ret, totalFilteredProducts };
    },
    getProductsForFactorySetting: async (factorySettingId) => {
      var userId = get(loggedInUserStore).uuid;
      var sortElement = "name";
      var sortDirection = 1;
      var ret = await db.products.where("userId").equals(userId).toArray();
      ret = ret.filter((p) => p.factorySettingId == factorySettingId);
      let totalFilteredProducts = ret.length;
      ret = ret.sort((f, g) =>
        f[sortElement] > g[sortElement] ? 1 * sortDirection : -1 * sortDirection
      );

      return { filteredProducts: ret, totalFilteredProducts };
    },
    makeInMemoryCopyOfFactorySetting: (settings) => {
      var x = JSON.safeStringify(settings);
      var y = JSON.parse(x);
      y.uuid = util.generateUUID();
      y.name = new Date().toLocaleDateString("en", {});
      return y;
    },
    findFactories: async (filter, numRecords) => {
      filter = filter.toLowerCase();
      var filterWords = filter.split(" ");
      var userId = get(loggedInUserStore).uuid;
      var userFactories = await db.factories
        .where("userId")
        .equals(userId)
        .toArray();
      var userVersions = await db.factorySettings
        .where("userId")
        .equals(userId)
        .toArray();

      var filteredVersionsEvery = userVersions.filter((fs) => {
        return (
          fs.name &&
          filterWords.every((fw) => fs.name.toLowerCase().includes(fw))
        );
      });
      var filteredVersionsSome = userVersions.filter((fs) => {
        return (
          fs.name &&
          filterWords.some((fw) => fs.name.toLowerCase().includes(fw))
        );
      });
      var filteredUserFactories = userFactories.filter(
        (uf) =>
          (uf &&
            filterWords.some(
              (fw) => uf.name && uf.name.toLowerCase().includes(fw)
            )) ||
          filteredVersionsSome.some((v) => v.factoryId == uf.uuid)
      );
      filteredUserFactories.map((f) => {
        if (filterWords.every((fw) => f.name.toLowerCase().includes(fw))) {
          // if the factory name matches search then we return all the versions for that one
          f.factorySettings = userVersions
            .filter((fv) => {
              return fv.factoryId == f.uuid;
            })
            .sort(sortByChangeDate);
        } else {
          if (filterWords.some((fw) => f.name.toLowerCase().includes(fw))) {
            f.factorySettings = filteredVersionsSome
              .filter((fv) => {
                return fv.factoryId == f.uuid;
              })
              .sort(sortByChangeDate);
          } else {
            f.factorySettings = filteredVersionsEvery
              .filter((fv) => {
                return fv.factoryId == f.uuid;
              })
              .sort(sortByChangeDate);
          }
        }
        f.lastSettingChangeDate =
          f.factorySettings.length > 0 && f.factorySettings[0].changeDate;
        return f;
      });
      filteredUserFactories = filteredUserFactories.filter(
        (uf) => uf.factorySettings.length > 0
      );
      return filteredUserFactories.slice(0, numRecords);
    },
    findFactorySettings: async (filter, numRecords) => {
      var allFactoriesWithSettings = await factoryStore.findFactories(
        filter,
        numRecords
      );
      let flat = allFactoriesWithSettings.flatMap((f) => {
        return (
          f.factorySettings &&
          f.factorySettings.map((v) => {
            return { version: v.name, factory: f.name, uuid: v.uuid };
          })
        );
      });
      return flat;
    },
    syncget: async () => {
      let factoryStoreVal = get(factoryStore);
      if (factoryStoreVal.onlinemode == "offline") {
        return;
      }
      if (isBusySync) {
        try {
          window.clearTimeout(syncTimeout);
        } catch (s) {}
        syncTimeout = window.setTimeout(factoryStore.syncget, 100);
        return;
      }
      isBusySync = true;
      update((n) => Object.assign(n, { isBusySync: true }));

      try {
        var userId = get(loggedInUserStore).uuid;
        var users = await db.users.where("uuid").equals(userId).toArray();
        var user = users[0];
        if (!user.lastSyncDateGet) {
          user.lastSyncDateGet = Date.parse("2000/1/1");
        }
        var ret = await util.fetchJsonWithMethod(
          "POST",
          "api/Sync/syncdataget",
          { userId: userId, fromDate: new Date(user.lastSyncDateGet) }
        );
        var shouldUpdate = false;
        for (var itemIndex in ret) {
          shouldUpdate = true;
          var item = ret[itemIndex];
          var itemObject = JSON.parse(item.json);
          var itemTable =
            db[item.tableName.replace("factorysettings", "factorySettings")];
          factoryStore.createOrUpdate(itemObject, itemTable, true, true);
        }
        if (shouldUpdate) {
          update((n) => Object.assign(n, { lastSyncDate: Date.now() }));
        }
        user.lastSyncDateGet = Date.now();
        await db.users.put(user, user.uuid);
      } catch (s) {
        alert("error sync " + s);
      }
      isBusySync = false;
      update((n) => Object.assign(n, { isBusySync: false }));
    },
    syncall: async () => {
      var factoryStoreVal = get(factoryStore);

      if (factoryStoreVal.onlinemode == "offline") {
        return "offline";
      }
      if (isBusySync) {
        try {
          window.clearTimeout(syncTimeout);
        } catch (s) {}

        syncTimeout = window.setTimeout(factoryStore.syncall, 400);
        return false;
      }
      isBusySync = true;

      try {
        var userId = get(loggedInUserStore).uuid;
        var users = await db.users.where("uuid").equals(userId).toArray();
        var user = users[0];
        if (!user.lastSyncDate) {
          user.lastSyncDate = Date.parse("2000/1/1");
        }
        var itemsToSync = [];

        var factoriesToSync = await db.factories
          .where("userId")
          .equals(userId)
          .and(function (item) {
            return !item.isSynced;
          })
          .toArray();

        itemsToSync = itemsToSync.concat(
          factoriesToSync.map((i) => {
            return {
              userId: userId,
              tableName: "factories",
              tableId: i.uuid,
              json: JSON.stringify(i),
              changeDate: i.changeDate,
              varValues: [],
            };
          })
        );
        var factorySettingsToSync = await db.factorySettings
          .where("userId")
          .equals(userId)
          .and(function (item) {
            return !item.isSynced;
          })
          .toArray();
        itemsToSync = itemsToSync.concat(
          factorySettingsToSync.map((i) => {
            return {
              userId: userId,
              tableName: "factorySettings",
              tableId: i.uuid,
              json: JSON.stringify(i),
              changeDate: i.changeDate,
              varValues: [],
            };
          })
        );

        var productsToSync = await db.products
          .where("userId")
          .equals(userId)
          .and(function (item) {
            return !item.isSynced;
          })
          .toArray();
        itemsToSync = itemsToSync.concat(
          productsToSync.map((i) => {
            return {
              userId: userId,
              tableName: "products",
              tableId: i.uuid,
              json: JSON.stringify(i),
              changeDate: i.changeDate,
              varValues: [],
            };
          })
        );

        var ret = await util.fetchJsonWithMethod(
          "POST",
          "api/Sync/syncdatasave",
          itemsToSync
        );
        user.lastSyncDatePush = Date.now();
        if (ret.success) {
          for (var item of factoriesToSync) {
            factoryStore.createOrUpdate(item, db.factories, true, true);
          }
          for (var item of factorySettingsToSync) {
            factoryStore.createOrUpdate(item, db.factorySettings, true, true);
          }
          for (var item of productsToSync) {
            factoryStore.createOrUpdate(item, db.products, true, true);
          }
        }
        await db.users.put(user, user.uuid);
      } catch (s) {
        alert("error sync " + s);
      }
      isBusySync = false;
      return true;
    },
    getCurrencySign: () => {
      var storeValue = get(factoryStore);
      var currencyNameObj = storeValue.currencies.find(
        (c) => c.id == storeValue.currentCalculator.alternateCurrencyId
      );
      var currencySign = "";
      if (currencyNameObj != null) {
        currencySign = currencyNameObj.htmlCode;
        // '<span class="prelabel prelabel-summary ' +
        // currencyNameObj.nameKey.toLowerCase() +
        // '"></span>';
      }
      return currencySign;
    },
    setMode: async (mode) => {
      update((n) => Object.assign(n, { onlinemode: mode }));
      localStorage.setItem("onlinemode", mode);
      if (mode == "online") {
        var ret = await factoryStore.syncall();
        if (ret == true) {
          await factoryStore.syncget();
          return "all data uploaded and up to date";
        } else {
          alert("something went wrong " + ret.message);
        }
      }
    },
    createOrUpdate: async (item, table, isSynced = false, keepDate = false) => {
      item.isSynced = isSynced;
      if (item.uuid == undefined || item.uuid == null) {
        item.uuid = util.generateUUID();
        if (!keepDate) item.changeDate = new Date().toJSON();
        var x = new Date().toISOString();
        item.userId = get(loggedInUserStore).uuid;
        await table.add(item);
      } else {
        var x = JSON.safeStringify(item);
        var y = JSON.parse(x);
        if (
          y.scenarioConfiguration &&
          y.scenarioConfiguration.calculatedScenarios
        )
          y.scenarioConfiguration.calculatedScenarios = [];
        var existingDBItem = await table.get(item.uuid);
        if (JSON.safeStringify(existingDBItem) != JSON.safeStringify(y)) {
          if (!keepDate) y.changeDate = new Date().toJSON();
          await table.put(y, item.uuid);
        }
      }
      return item.uuid;
    },
  };
}

export const factoryStore = createMyStore();

// we use this function to remove the circular references from the object structure before saving to Dexie / IndexedDB
JSON.safeStringify = (obj, indent = 2) => {
  let cache = [];
  const retVal = JSON.stringify(
    obj,
    (key, value) =>
      typeof value === "object" && value !== null
        ? cache.includes(value)
          ? undefined // Duplicate reference found, discard key
          : cache.push(value) && value // Store value in our collection
        : value,
    indent
  );
  cache = null;
  return retVal;
};
